import { combineReducers } from "redux";
import appState from "./reducers/appStateReducer";
import appSettings from "./reducers/appSettingsReducer";
import bosUser from "./reducers/bosUserReducer";
import solutionsCache from "./reducers/solutionsCacheReducer";
import dataSegments from "./reducers/dataSegmentReducer";
import sessions from "./reducers/sessionReducer";

export const reducers = {
  appState,
  appSettings,
  bosUser,
  solutionsCache,
  dataSegments,
  sessions,
}

const rootReducer = combineReducers(reducers);

export default rootReducer;